import { IconBtn } from 'ctls/inputs/IconBtn';
import { Modal, ModalWrap } from 'ctls/modal/Modal';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { usePromise } from 'hooks/usePromise';
import { useRefComponent } from 'hooks/useRefComponent';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { useAiMsg } from 'search2/aisrch/useAiMsg';
import svcs from 'services';
import { useSvrInfo } from 'store/reducers/reducerMain';
import styled from 'styled-components';
import { create } from 'zustand';

export const useZstdPopAiChatbot = create<{ visible: boolean; setVisible: (v: boolean) => void }>((set) => ({
  visible: false,
  setVisible: (v: boolean) => set({ visible: v }),
}));

type Props = {
  show(): Promise<any>;
};
export const PopAiChatbot = forwardRef<Props, {}>((props, ref) => {
  const promise = usePromise<{}, { cmd?: string }>();
  const { visible, setVisible } = useZstdPopAiChatbot();
  const [sessionId, setSessionId] = useLocalStorage('ai_session_id_popup', '');
  useImperativeHandle(ref, () => ({
    show: () => {
      return new Promise((resolve, reject) => {
        promise.current = { resolve, reject };
        setVisible(true);
      });
    },
  }));

  const handleClose = () => {
    setVisible(false);
    if (promise.current) {
      if (promise.current.reject) {
        promise.current.reject({ cmd: 'close' });
      }
      promise.current.reject = undefined;
      promise.current.resolve = undefined;
    }
  };

  useAiMsg(
    'popup',
    (msg) => {
      console.log('msg in popup', msg);
      if (msg.session_id) {
        if (msg.session_id !== sessionId && msg.session_id) {
          console.log('session_id changed', msg.session_id);
          setSessionId(msg.session_id);
        }
      }
    },
    [sessionId]
  );

  //if (!visible) return null;
  //const aibot = 'https://ssqchatbot-app-g9d2bhgudeduhse3.koreacentral-01.azurewebsites.net/';
  const { svrConf } = useSvrInfo();
  const siteLanguage = svcs.svcLang.getLanguage();
  //const chatbotUrl = svrConf.chatbotUrl;
  //const chatbotUrl = 'https://ssqchatbot-dev.azurewebsites.net?type=popup&session_id=' + sessionId;
  const chatbotUrl = svrConf.chatbotUrl + '?type=popup&session_id=' + sessionId + '&site_language=' + siteLanguage;

  useEffect(() => {
    console.log('ai popup chatbotUrl', chatbotUrl);
  }, [chatbotUrl]);
  return (
    <Modal onClick={(e) => e.stopPropagation()} visible={visible}>
      <Body>
        <CloseBtn btnType='close' onClick={handleClose} />
        <Iframe src={chatbotUrl} allow='microphone;' />
      </Body>
    </Modal>
  );
});

PopAiChatbot.displayName = 'PopAiChatbot';

const CloseBtn = styled(IconBtn)`
  position: absolute;
  top: 2.6rem;
  right: 1.6rem;
  width: 2.4rem;
  height: 2.4rem;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
`;
const Body = styled(ModalWrap)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  max-height: 800px;
`;

export const usePopAiChatbot = () => useRefComponent<Props>(PopAiChatbot);
